import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconThumbsUp: React.NamedExoticComponent<CentralIconBaseProps> = React.memo(React.forwardRef<SVGSVGElement, CentralIconBaseProps>((props, ref) => {
  return <CentralIconBase {...props} ref={ref} ariaLabel={"thumbs-up, thumb, hand, yes, pro"} maskId="square-filled-radius-0-stroke-1-IconThumbsUp"><path fillRule="evenodd" clipRule="evenodd" d="M11.6605 2H10.7575L6.20911 10H2V21H17.4675C19.1739 21 20.6315 19.7695 20.9179 18.0873L21.8966 12.3373C22.2603 10.2004 20.6139 8.25 18.4462 8.25H13.601L14.1301 4.88876C14.3689 3.37171 13.1963 2 11.6605 2ZM6 11V20H3V11H6Z" fill="currentColor"/></CentralIconBase>;
}));

export default IconThumbsUp;
